import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)


/*
 * /mypage
*/

/*
 * Woo My Account nav -> select (mobile)
*/
(function () {
  function initMyAccountNavSelect() {
    // マイページ判定（Woo標準の body class）
    if (!document.body.classList.contains('woocommerce-account')) return;

    const nav = document.querySelector('.woocommerce-MyAccount-navigation');
    const content = document.querySelector('.woocommerce-MyAccount-content');
    if (!nav || !content) return;

    // SPだけ（CSSと合わせる）
    const mq = window.matchMedia('(max-width: 767px)');
    if (!mq.matches) return;

    // 二重生成防止
    if (document.querySelector('.mypage-nav-select')) return;

    const links = nav.querySelectorAll('a');
    if (!links.length) return;

    const wrap = document.createElement('div');
    wrap.className = 'mypage-nav-select';

    const select = document.createElement('select');
    select.id = 'mypage-nav-select';
    select.name = 'mypage-nav-select';
    select.setAttribute('aria-label', 'マイページメニュー');

    const normalize = (url) => url.replace(/\/+$/, '');
    const currentNorm = normalize(window.location.origin + window.location.pathname);

    links.forEach((a) => {
      const href = a.getAttribute('href');
      if (!href) return;

      const opt = document.createElement('option');
      opt.value = href;
      opt.textContent = (a.textContent || '').trim();

      // is-active 優先 + URL一致 fallback
      const li = a.closest('li');
      const isActive = li && li.classList.contains('is-active');

      let linkNorm = '';
      try {
        const u = new URL(href, window.location.origin);
        linkNorm = normalize(u.origin + u.pathname);
      } catch (e) {}

      if (isActive || (linkNorm && linkNorm === currentNorm)) {
        opt.selected = true;
      }

      select.appendChild(opt);
    });

    select.addEventListener('change', function () {
      const url = this.value;
      if (url) window.location.href = url;
    });

    wrap.appendChild(select);

    // コンテンツの直前に挿入（2カラムで自然）
    content.parentNode.insertBefore(wrap, content);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMyAccountNavSelect);
  } else {
    initMyAccountNavSelect();
  }
})();

// Responsive
(function () {
  const mq = window.matchMedia('(max-width: 767px)');

  function handler() {
    const existing = document.querySelector('.mypage-nav-select');
    if (mq.matches) {
      if (!existing) {
        // さっきの init を呼ぶ
        // initMyAccountNavSelect(); // 同スコープにあるならこれ
      }
    } else {
      if (existing) existing.remove();
    }
  }

  mq.addEventListener ? mq.addEventListener('change', handler) : mq.addListener(handler);
})();
